/* eslint-disable */
/**
 * Realistic mock data for /admin-demo route.
 * Designed to wow prospects: healthy traffic, busy enquiries inbox, active shop.
 *
 * All data is module-scoped & mutable so demo session feels live (deletes hide
 * items, edits update them) — but it resets on page reload (no DB writes).
 */
import { PROJECT_BUILDER_DEFAULTS } from './demoBuilderDefaults';

const now = Date.now();
const minutes = (m) => new Date(now - m * 60_000).toISOString();
const hours = (h) => new Date(now - h * 3_600_000).toISOString();
const days = (d) => new Date(now - d * 86_400_000).toISOString();

// ───────────────────── ENQUIRIES ─────────────────────
export let enquiries = [
  {
    id: 'sub-001', name: 'Olivia Bennett', email: 'olivia@bennettstudio.co.uk',
    phone: '07700 900112', service: 'Quote Builder · Growth',
    budget: '£1,200 setup + £49/mo', care_plan: 'Growth Care', source: 'quote_builder',
    message: '[Quote Builder]\n\nTier: Growth\nBolt-ons: Booking system, Blog\nCare plan: Growth Care\nHosting: Boost\nTimeline: 3-4 weeks\n\nHi Danny, looking to launch a refreshed site for our interior design studio in Bournemouth. Loved the work on the Restaurants demo. Can we book a discovery call this week?',
    consent: { timestamp: minutes(8), ip_address: '92.31.44.18', terms_version: '1.2', privacy_version: '1.3', consent_string: 'TERMS-1.2|PRIV-1.3|2025-12-04T11:32:08Z' },
    created_at: minutes(8),
  },
  {
    id: 'sub-002', name: 'Marcus Hall', email: 'marcus@hallandsons.com',
    phone: '07911 244 901', service: 'Quote Builder · Starter',
    budget: '£800 setup + £19/mo', care_plan: 'Essential Care', source: 'quote_builder',
    message: '[Quote Builder]\n\nTier: Starter\nBolt-ons: Google Maps, Reviews widget\nCare plan: Essential Care\nHosting: Standard\n\nNeed a clean 3-page site for our family-run plumbing business. Existing site is wordpress and slow.',
    created_at: hours(2),
  },
  {
    id: 'sub-003', name: 'Aisha Patel', email: 'aisha@brewlanecafe.co.uk',
    phone: '07825 660 414', service: 'General enquiry', budget: 'Under £500',
    message: 'Do you offer just a logo + business card? We have a brand new café opening in March and need print-ready files.',
    created_at: hours(5),
  },
  {
    id: 'sub-004', name: 'Tom Reilly', email: 'tom.reilly@reillyfit.com',
    phone: '07476 312 008', service: 'Quote Builder · Pro',
    budget: '£2,400 setup + £79/mo', care_plan: 'VIP Care', source: 'quote_builder',
    message: '[Quote Builder]\n\nTier: Pro\nBolt-ons: Member portal, Class booking, Stripe checkout\nCare plan: VIP Care\nHosting: Pro\nTimeline: ASAP\n\nOpening a new gym in Christchurch — need everything: site, booking, member logins, branded merch shop.',
    created_at: hours(9),
  },
  {
    id: 'sub-005', name: 'Sarah Jenkins', email: 'sarahj@jenkinslegal.co.uk',
    phone: '01202 511 044', service: 'Care plan upgrade',
    message: 'Currently on Essential, would like to move to Growth. Our blog is taking off.',
    created_at: days(1),
  },
  {
    id: 'sub-006', name: 'David Owusu', email: 'd.owusu@owusubarbers.com',
    service: 'Quote Builder · Local Launch',
    budget: '£399 setup', source: 'quote_builder',
    message: '[Quote Builder]\n\nTier: Local Launch\nCare plan: skipped (code-export)\n\nJust need a one-pager for the barbershop. Will host elsewhere.',
    created_at: days(1),
  },
  {
    id: 'sub-007', name: 'Emma Foster', email: 'emma@fosterceramics.shop',
    phone: '07590 888 124', service: 'E-commerce', budget: '£2k+',
    message: 'Hand-thrown ceramics shop. Need stripe checkout and a print-on-demand integration for posters.',
    created_at: days(2),
  },
  {
    id: 'sub-008', name: 'James Whitcombe', email: 'james@whitcombeproperty.uk',
    phone: '07703 451 902', service: 'Rebuild',
    budget: '£3k', message: 'Estate agency in Poole. Existing site is dated. Want something premium with a property listings system.',
    created_at: days(3),
  },
  {
    id: 'sub-009', name: 'Priya Sharma', email: 'priya@sharmaaccountancy.co.uk',
    service: 'General enquiry', message: 'Can you redirect from our old domain when migrating? It has 8 years of SEO juice we cant lose.',
    created_at: days(4),
  },
  {
    id: 'sub-010', name: 'Connor Walsh', email: 'connor@walshconstruction.ie',
    phone: '+353 86 555 0192', service: 'Quote Builder · Growth',
    budget: '£1,200 + £49/mo', care_plan: 'Growth Care', source: 'quote_builder',
    message: '[Quote Builder]\n\nTier: Growth\nBolt-ons: Project gallery, Quote calculator\n\nIrish construction firm, want to expand into UK market. Need a site that ranks for both regions.',
    created_at: days(5),
  },
  {
    id: 'sub-011', name: 'Beth Carlile', email: 'beth@carlilebakery.co.uk',
    phone: '07412 909 301', service: 'Print job',
    message: 'Need 500 branded paper bags and 200 flyers for our launch event in Boscombe. Can you handle the printing too?',
    created_at: days(6),
  },
  {
    id: 'sub-012', name: 'Raj Mehta', email: 'raj@mehtaautomotive.com',
    service: 'Care plan downgrade', message: 'Need to drop from Growth to Essential — can we discuss timing?',
    created_at: days(8),
  },
];

// ───────────────────── ANALYTICS ─────────────────────
// Build a realistic 30-day series with an upward trend
function genSeries(daysCount, base, variance, growth) {
  const out = [];
  for (let i = daysCount - 1; i >= 0; i--) {
    const d = new Date(now - i * 86_400_000);
    const dayBoost = (daysCount - i) * growth;
    const noise = (Math.sin(i * 1.3) + Math.cos(i * 0.7)) * variance;
    const weekendDrop = (d.getDay() === 0 || d.getDay() === 6) ? -base * 0.18 : 0;
    out.push({
      date: d.toISOString().slice(0, 10),
      visitors: Math.max(40, Math.round(base + dayBoost + noise + weekendDrop)),
      pageviews: Math.max(80, Math.round((base + dayBoost + noise + weekendDrop) * 2.4)),
    });
  }
  return out;
}

// AnalyticsManager expects: overview, daily[{date,users,views}], top_pages[{path,views}],
// sources[{channel,sessions}], countries[{country,users}], devices[{device,sessions}],
// and realtime_users.
//
// Exposed as a function so the /api/admin/analytics/dashboard?days=N interceptor
// can generate a fresh, range-aware payload — more visitors over longer ranges,
// with steady growth so 7→30→90 actually changes.
export function buildAnalytics(rangeDays = 30) {
  const days = Math.max(1, Math.min(365, Number(rangeDays) || 30));
  // Base daily visitors scales gently with range (longer ranges include
  // older, slightly lower-traffic days) — but never below 110.
  const base = days <= 7 ? 285 : days <= 30 ? 230 : days <= 90 ? 180 : 140;
  const variance = days <= 7 ? 22 : days <= 30 ? 32 : 50;
  const growth = days <= 7 ? 4.8 : days <= 30 ? 2.6 : 1.6;
  const series = genSeries(days, base, variance, growth);
  const totalUsers = series.reduce((s, d) => s + d.visitors, 0);
  const totalViews = series.reduce((s, d) => s + d.pageviews, 0);

  // Top pages / sources / countries / devices scale roughly with traffic
  const scale = totalUsers / 6620;
  const pages = [
    { path: '/',                                       base: 4218 },
    { path: '/pricing',                                base: 2104 },
    { path: '/services',                               base: 1612 },
    { path: '/web-design-bournemouth',                 base: 1041 },
    { path: '/contact',                                base: 892 },
    { path: '/blog/seo-for-small-business',            base: 614 },
    { path: '/web-design-restaurants-bournemouth',     base: 488 },
    { path: '/shop',                                   base: 420 },
  ].map(p => ({ path: p.path, views: Math.max(8, Math.round(p.base * scale)) }));

  const sources = [
    { channel: 'Organic Search', base: 5218 },
    { channel: 'Direct',         base: 1840 },
    { channel: 'Organic Social', base: 712 },
    { channel: 'Paid Social',    base: 488 },
    { channel: 'Referral',       base: 422 },
    { channel: 'Email',          base: 320 },
  ].map(s => ({ channel: s.channel, sessions: Math.max(5, Math.round(s.base * scale)) }));

  const countries = [
    { country: 'United Kingdom', base: 6840 },
    { country: 'Ireland',        base: 412 },
    { country: 'United States',  base: 384 },
    { country: 'Spain',          base: 211 },
    { country: 'France',         base: 144 },
  ].map(c => ({ country: c.country, users: Math.max(3, Math.round(c.base * scale)) }));

  const devices = [
    { device: 'mobile',  base: 6120 },
    { device: 'desktop', base: 2440 },
    { device: 'tablet',  base: 460 },
  ].map(d => ({ device: d.device, sessions: Math.max(8, Math.round(d.base * scale)) }));

  // Bounce rate edges down slightly the more data you see; engagement edges up
  const bounce = Math.max(24, Math.round(34 - Math.min(10, days / 10)));
  const engagement = Math.min(78, Math.round(64 + Math.min(14, days / 9)));

  return {
    range_days: days,
    realtime_users: 8 + Math.round(Math.random() * 14),
    overview: {
      total_users: totalUsers,
      page_views: totalViews,
      sessions: Math.round(totalUsers * 1.18),
      new_users: Math.round(totalUsers * 0.62),
      avg_session_duration: 132 + Math.round(Math.min(28, days / 4)),
      bounce_rate: bounce,
      engagement_rate: engagement,
    },
    daily: series.map(d => ({ date: d.date, users: d.visitors, views: d.pageviews })),
    top_pages: pages,
    sources,
    countries,
    devices,
  };
}

// Default snapshot (30-day) — kept for back-compat with anything that still
// imports the static object.
export const analyticsDashboard = buildAnalytics(30);

export const analyticsSettings = {
  ga4_property_id: '— demo —',
  ga4_connected: true,
  service_account_email: 'demo-analytics@uidesigns-demo.iam.gserviceaccount.com',
};

// ───────────────────── BLOG ─────────────────────
export let blogPosts = [
  { id: 'p-1', title: 'SEO for small businesses in Bournemouth — the 2026 playbook', slug: 'seo-for-small-business', excerpt: 'Local SEO has changed. Here\'s the simple checklist we run for every Bournemouth client.', tag: 'SEO', keywords: 'local SEO, Bournemouth web design, small business SEO', read_time: 7, content: '<h2>Local SEO essentials</h2><p>Local search has shifted dramatically...</p>', published_at: days(2) },
  { id: 'p-2', title: 'Why £399 websites are not as cheap as they look', slug: 'cheap-websites-true-cost', excerpt: 'The hidden costs of bargain-bin web builders — and how to avoid them.', tag: 'Pricing', keywords: 'cheap websites, web design pricing', read_time: 6, content: '<h2>Lifetime cost matters</h2><p>...</p>', published_at: days(8) },
  { id: 'p-3', title: 'How a barber in Boscombe doubled bookings in 6 weeks', slug: 'barber-bookings-case-study', excerpt: 'A small redesign + Google Business overhaul. Here\'s the breakdown.', tag: 'Case study', keywords: 'barber web design, Bournemouth case study', read_time: 5, content: '<p>Case study content...</p>', published_at: days(14) },
  { id: 'p-4', title: 'Care plans — the real reason your site stops earning', slug: 'why-you-need-a-care-plan', excerpt: 'Most small business sites die quietly within a year. Here\'s why.', tag: 'Care', keywords: 'website care plan, hosting bournemouth', read_time: 8, content: '<p>Reasons explained...</p>', published_at: days(21) },
  { id: 'p-5', title: 'A simple admin panel = fewer support emails', slug: 'admin-panel-saves-time', excerpt: 'Why every site we build comes with an admin panel — and why our clients love it.', tag: 'Product', keywords: 'admin panel, website CMS, easy edits', read_time: 4, content: '<p>...</p>', published_at: days(28) },
];

// ───────────────────── PRICING / PROJECT BUILDER ─────────────────────
export const pricingState = {
  packages: [
    { id: 'starter', name: 'Starter', price: 800, monthly_addon: 19, features: ['3 pages', 'Mobile-first', 'Basic SEO', 'Contact form', 'SSL'] },
    { id: 'growth', name: 'Growth', price: 1200, monthly_addon: 49, popular: true, features: ['Up to 8 pages', 'Custom design', 'Blog', 'Bookings', 'Analytics'] },
    { id: 'pro', name: 'Pro', price: 2400, monthly_addon: 79, features: ['Unlimited pages', 'E-commerce ready', 'Member areas', 'Stripe checkout', 'Priority support'] },
  ],
  local_launch: { name: 'Local Launch Website', price: '399', description: 'One-pager. Online in 5 working days.', features: ['1 page', 'Click-to-call', 'Domain + hosting', 'SSL'] },
  bolt_ons: [
    { id: 'blog', name: 'Blog & SEO articles', price: 200, monthly: 0 },
    { id: 'booking', name: 'Booking system', price: 350, monthly: 5 },
    { id: 'shop', name: 'Stripe shop', price: 600, monthly: 9 },
    { id: 'reviews', name: 'Reviews widget', price: 90, monthly: 0 },
  ],
  care_plans: {
    feature_labels: ['Hosting', 'Admin panel', 'Updates', 'Backups', 'Priority support'],
    plans: [
      { id: 'essential', name: 'Essential', price_monthly: 19, features: ['Standard hosting', 'Admin panel', 'Quarterly updates', 'Daily backups'] },
      { id: 'growth', name: 'Growth', price_monthly: 49, popular: true, features: ['Boosted hosting', 'Admin panel', 'Monthly updates', 'Daily backups', 'Email support'] },
      { id: 'vip', name: 'VIP', price_monthly: 89, features: ['Premium hosting', 'Admin panel', 'Weekly updates', 'Hourly backups', 'Phone + email priority'] },
    ],
  },
  project_builder: PROJECT_BUILDER_DEFAULTS,
};

// ───────────────────── PRODUCTS / SHOP ─────────────────────
// Product schema mirrors backend: `title`, `base_price`, `views[]`, `color_variants[]`, `sub_options[]`.
export let products = [
  { id: 'prd-1', title: 'Premium Business Cards', slug: 'premium-business-cards', base_price: 24.99, sale_price: null, category: 'Print', image: '', views: [{ name: 'Front' }, { name: 'Back' }], color_variants: [{ name: 'White' }, { name: 'Black' }], sub_options: [], status: 'active', sort: 1, sales_30d: 42 },
  { id: 'prd-2', title: 'Branded Paper Bags (250 pack)', slug: 'paper-bags', base_price: 119.00, sale_price: 99.00, category: 'Packaging', image: '', views: [{ name: 'Front' }], color_variants: [{ name: 'Kraft' }], sub_options: [], status: 'active', sort: 2, sales_30d: 18 },
  { id: 'prd-3', title: 'Roller Banner — 800x2000mm', slug: 'roller-banner', base_price: 79.00, sale_price: null, category: 'Display', image: '', views: [{ name: 'Front' }], color_variants: [], sub_options: [], status: 'active', sort: 3, sales_30d: 12 },
  { id: 'prd-4', title: 'A5 Flyers (500 pack)', slug: 'a5-flyers', base_price: 49.00, sale_price: 39.00, category: 'Print', image: '', views: [{ name: 'Front' }, { name: 'Back' }], color_variants: [], sub_options: [], status: 'active', sort: 4, sales_30d: 31 },
  { id: 'prd-5', title: 'Vinyl Stickers (100 pack)', slug: 'vinyl-stickers', base_price: 34.00, sale_price: null, category: 'Print', image: '', views: [{ name: 'Front' }], color_variants: [{ name: 'White' }, { name: 'Holographic' }], sub_options: [], status: 'active', sort: 5, sales_30d: 56 },
  { id: 'prd-6', title: 'Window Decals — Custom', slug: 'window-decals', base_price: 89.00, sale_price: null, category: 'Display', image: '', views: [{ name: 'Front' }], color_variants: [], sub_options: [], status: 'sold_out', sort: 6, sales_30d: 7 },
];

// ───────────────────── ORDERS ─────────────────────
export let orders = [
  { id: 'ord-2841', order_number: 'UID-2841', customer_name: 'Olivia Bennett', customer_email: 'olivia@bennettstudio.co.uk', phone: '07700 900112', product_title: 'Branded Paper Bags (250 pack)', order_status: 'in_production', payment_status: 'paid', total_price: 99.00, discount_percent: 0, shipping_cost: 4.99, shipping_address: { full_name: 'Olivia Bennett', address_line1: '47 Westcliff Road', city: 'Bournemouth', postcode: 'BH4 8DG', country: 'United Kingdom' }, selected_options: [{ name: 'Quantity', value: '250' }], created_at: hours(3), archived: false },
  { id: 'ord-2840', order_number: 'UID-2840', customer_name: 'Marcus Hall', customer_email: 'marcus@hallandsons.com', phone: '07911 244 901', product_title: 'A5 Flyers (500 pack)', order_status: 'paid', payment_status: 'paid', total_price: 49.00, discount_percent: 0, shipping_cost: 4.99, shipping_address: { full_name: 'Marcus Hall', address_line1: '12 Old Town Square', city: 'Poole', postcode: 'BH15 1AB', country: 'United Kingdom' }, selected_options: [{ name: 'Quantity', value: '500' }], created_at: hours(7), archived: false },
  { id: 'ord-2839', order_number: 'UID-2839', customer_name: 'Beth Carlile', customer_email: 'beth@carlilebakery.co.uk', phone: '07412 909 301', product_title: 'Branded Paper Bags (250 pack)', order_status: 'shipped', payment_status: 'paid', total_price: 198.00, discount_percent: 10, discount_code: 'LAUNCH20', shipping_cost: 0, shipping_address: { full_name: 'Beth Carlile', address_line1: '8 Christchurch Road', city: 'Boscombe', postcode: 'BH1 4AN', country: 'United Kingdom' }, selected_options: [{ name: 'Quantity', value: '500' }], created_at: days(1), archived: false },
  { id: 'ord-2838', order_number: 'UID-2838', customer_name: 'Tom Reilly', customer_email: 'tom.reilly@reillyfit.com', product_title: 'Roller Banner — 800x2000mm', order_status: 'delivered', payment_status: 'paid', total_price: 79.00, discount_percent: 0, shipping_cost: 4.99, shipping_address: { full_name: 'Tom Reilly', address_line1: '5 Bargates', city: 'Christchurch', postcode: 'BH23 1QD', country: 'United Kingdom' }, selected_options: [], created_at: days(2), archived: false },
  { id: 'ord-2837', order_number: 'UID-2837', customer_name: 'David Owusu', customer_email: 'd.owusu@owusubarbers.com', product_title: 'Premium Business Cards', order_status: 'in_production', payment_status: 'paid', total_price: 24.99, discount_percent: 0, shipping_cost: 4.99, shipping_address: { full_name: 'David Owusu', address_line1: '34 Charminster Road', city: 'Bournemouth', postcode: 'BH8 8UE', country: 'United Kingdom' }, selected_options: [], created_at: days(2), archived: false },
  { id: 'ord-2836', order_number: 'UID-2836', customer_name: 'Aisha Patel', customer_email: 'aisha@brewlanecafe.co.uk', product_title: 'A5 Flyers + Vinyl Stickers', order_status: 'paid', payment_status: 'paid', total_price: 73.00, discount_percent: 0, shipping_cost: 4.99, shipping_address: { full_name: 'Aisha Patel', address_line1: '21 Brew Lane', city: 'Bournemouth', postcode: 'BH9 1NS', country: 'United Kingdom' }, selected_options: [], created_at: days(3), archived: false },
  { id: 'ord-2835', order_number: 'UID-2835', customer_name: 'Sarah Jenkins', customer_email: 'sarahj@jenkinslegal.co.uk', product_title: 'Premium Business Cards', order_status: 'delivered', payment_status: 'paid', total_price: 24.99, discount_percent: 0, shipping_cost: 4.99, shipping_address: { full_name: 'Sarah Jenkins', address_line1: '102 Richmond Hill', city: 'Bournemouth', postcode: 'BH2 6HE', country: 'United Kingdom' }, selected_options: [], created_at: days(4), archived: false },
  { id: 'ord-2834', order_number: 'UID-2834', customer_name: 'Connor Walsh', customer_email: 'connor@walshconstruction.ie', product_title: 'Window Decals + Roller Banner', order_status: 'shipped', payment_status: 'paid', total_price: 168.00, discount_percent: 0, shipping_cost: 12.99, shipping_address: { full_name: 'Connor Walsh', address_line1: '14 Cork Street', city: 'Dublin', postcode: 'D02 X285', country: 'Ireland' }, selected_options: [], created_at: days(6), archived: false },
];

// ───────────────────── DISCOUNTS ─────────────────────
export let discounts = [
  { id: 'dc-1', code: 'LAUNCH20', percent: 20, active: true, uses: 14, max_uses: 100, min_order: 25.00, expires_at: days(-30) },
  { id: 'dc-2', code: 'XMAS10', percent: 10, active: false, uses: 87, max_uses: 100, min_order: 0, expires_at: days(40) },
  { id: 'dc-3', code: 'TRADE15', percent: 15, active: true, uses: 6, max_uses: null, min_order: 100.00, expires_at: null },
];

export const saleBanner = {
  enabled: true,
  text: '25% off all Print orders this weekend',
  cta_label: 'Shop the sale',
  cta_url: '/shop',
  bg_color: '#00E5FF',
  text_color: '#0A0A0A',
};

export const shopSettings = {
  free_shipping_threshold: 75,
  base_shipping: 4.99,
  vat_rate: 0.20,
  currency: 'GBP',
};

// ───────────────────── ACCOUNTS / RBAC ─────────────────────
export let accounts = [
  { id: 'a-1', name: 'Danny (Owner)', email: 'admin@uidesigns.co.uk', role: 'admin', permissions: ['*'], created_at: days(380) },
  { id: 'a-2', name: 'Sophie Marsh', email: 'sophie@uidesigns.co.uk', role: 'staff', permissions: ['enquiries', 'blog', 'contact'], created_at: days(120) },
  { id: 'a-3', name: 'Liam Rourke', email: 'liam@uidesigns.co.uk', role: 'staff', permissions: ['products', 'orders', 'discounts'], created_at: days(64) },
  { id: 'a-4', name: 'Holly Tate', email: 'holly@uidesigns.co.uk', role: 'staff', permissions: ['analytics', 'pricing'], created_at: days(28) },
];

// ───────────────────── CONTACT FORM ─────────────────────
export const contactSettings = {
  dropdowns: {
    service: { options: ['New website', 'Care plan upgrade', 'Print job', 'General enquiry', 'Just saying hi'], default_option: 'New website' },
    budget: { options: ['Under £500', '£500 — £1,200', '£1,200 — £3,000', '£3,000+', 'Not sure yet'], default_option: '£500 — £1,200' },
    care_plan: { options: ['No care plan', 'Essential Care', 'Growth Care', 'VIP Partnership', 'Not sure'], default_option: 'Not sure' },
  },
  send_to_email: 'demo@uidesigns.co.uk',
  auto_reply_enabled: true,
};

// ───────────────────── LEGAL PAGES ─────────────────────
export const legal = {
  privacy: {
    title: 'Privacy Policy',
    last_updated: days(45),
    content: '<h2>Demo Privacy Policy</h2><p>This is a demo. Real privacy policy content lives here, fully editable in the admin panel.</p>',
  },
  terms: {
    title: 'Terms of Service',
    last_updated: days(45),
    content: '<h2>Demo Terms of Service</h2><p>This is a demo. Real T&Cs are edited inline using a TipTap rich-text editor.</p>',
  },
};

// ───────────────────── DEMO SESSION USER ─────────────────────
export const demoUser = {
  id: 'demo-admin',
  name: 'Demo Admin',
  email: 'demo@uidesigns.co.uk',
  role: 'admin',
  permissions: ['enquiries', 'blog', 'pricing', 'products', 'orders', 'discounts', 'legal', 'contact', 'analytics', 'accounts'],
};
